export default __webpack_public_path__ + "static/new8-02-154f9c5c870373e15d63390e71e0a5e1.jpg";